import {$} from './jquery-definition.js';
import SmoothScroll from 'smooth-scroll';
import '@fancyapps/fancybox';

var smoothScroll = new SmoothScroll( 'a[href*="#"]', {
	topOnEmptyHash: false,
	updateURL: false,
	speed: 1000,
	speedAsDuration: true,
} );

var navTimeouts = [];

$( function() {
	sanitizeTargetBlank();

	// Add classes based on scroll position/direction
	var $html = $( 'html' );
	var lastScroll = 0;
	var newScroll = 0;
	var menuAutoHider;

	$( window ).on( 'scroll', function( event ) {
		newScroll = $( window ).scrollTop();
		clearTimeout( menuAutoHider );

		if ( newScroll > 0 && !$( 'body' ).hasClass( 'active-navigation' ) ) {
			$html.removeClass( 'at-top' );

			if ( newScroll > lastScroll + 30 ) {
				$html.removeClass( 'scrolled-up' );
				$html.addClass( 'scrolled-down' );
				lastScroll = newScroll;
			} else if ( newScroll < lastScroll - 30 ) {
				$html.addClass( 'scrolled-up' );
				$html.removeClass( 'scrolled-down' );

				menuAutoHider = setTimeout( function() {
					$html.removeClass( 'scrolled-up' ).addClass( 'scrolled-down' );
				}, 5000 );
				lastScroll = newScroll;
			}
		} else {
			$html.removeClass( 'scrolled-up' ).removeClass( 'scrolled-down' ).addClass( 'at-top' );
		}
	} );

	// Toggle
	$( '.toggle' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();

		var $this = $( this );
		var $target = $( $this.attr( 'data-target' ) );

		$this.toggleClass( 'active' );
		$target.toggleClass( 'active' );
		$( 'body' ).toggleClass( $this.attr( 'data-body-class' ) );

		if ( !$this.hasClass( 'site-navigation-control' ) ) {
			closeMenu();
		}
	} );

	$( '.site-navigation-control-open' ).on( 'click', function( clickEvent ) {
		var $this = $( this );

		$this.addClass( 'active' );

		$( '.site-navigation-container a' ).each( function( index ) {
			var $this = $( this );

			navTimeouts.push( setTimeout( function() {
				$this.addClass( 'active' );
			}, 150 + index * 100 ) );
		} );
	} );

	$( '.site-navigation-control-close' ).on( 'click', function( clickEvent ) {
		var $this = $( this );

		closeMenu();
	} );

	// $( '.site-navigation-container a' ).on( 'click', function() {
	// 	closeMenu();
	// } );

	$( 'input[name="display"]' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();

		var $this = $( this );
		var value = $this.attr( 'value' );

		if ( value == 'image' ) {
			$( '#list-container' ).addClass( 'd-none' );
			$( '#image-container' ).removeClass( 'd-none' );
			$( window ).scrollTop( $( window ).scrollTop() + 1 );
		} else if ( value == 'list' ) {
			$( '#list-container' ).removeClass( 'd-none' );
			$( '#image-container' ).addClass( 'd-none' );
			$( window ).scrollTop( $( window ).scrollTop() + 1 );
		}
	} );

	$( '.intro-overlay' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();

		var $this = $( this );

		$this.removeClass( 'active' );
		$( 'body' ).removeClass( 'active-intro-overlay' );
	} );

	setTimeout( function() {
		$( '.intro-overlay' ).removeClass( 'active' );
		$( 'body' ).removeClass( 'active-intro-overlay' );
	}, 3500 );

	$( '.gallery a' ).fancybox( {} );

	$( '[data-filter]' ).on( 'click', function( clickEvent ) {
		var $this = $( this );

		var filter = $this.attr( 'data-filter' );

		$( '.filter-item' ).addClass( 'inactive' ).removeClass( 'last-item' );

		$( filter ).removeClass( 'inactive' );

		$( '.filter-item:not(.inactive):last' ).addClass( 'last-item' );

		$( window ).scrollTop( $( window ).scrollTop() + 1 );
	} );

	$( '.accordion-toggle' ).on( 'click', function() {
		const $this = $( this );
		const $target = $( $this.attr( 'data-target' ) );

		$target.toggle( 200 );
		$this.find( '.icon' ).toggleClass( '!-scale-y-100' );
	} );

	$( '.site-navigation .menu-item-has-children > a' ).on( 'click', function( event ) {
		event.preventDefault();
		$( this ).toggleClass( 'current-active' );
		$( this ).parent().find( '.sub-menu' ).toggle( 300 );
	} );

	$( '.marker' ).on( 'click', function( event ) {
		event.preventDefault();

		var targetId = $( this ).data( 'target' );
		var $targetDiv = $( '[data-window-id="' + targetId + '"]' );
		var $anchor = $( this );
		var $container = $( this ).closest( '.image-container' );

		// Close all other windows
		$( '.window' ).not( $targetDiv ).addClass( 'opacity-0 pointer-events-none' );

		// Toggle the visibility and interaction of the target div
		$targetDiv.toggleClass( 'opacity-0 pointer-events-none' );

		// Get position and dimensions
		var anchorOffset = $anchor.offset();
		var containerOffset = $container.offset();
		var containerWidth = $container.width();
		var containerHeight = $container.height();
		var targetWidth = $targetDiv.outerWidth();
		var targetHeight = $targetDiv.outerHeight();
		var anchorWidth = $anchor.outerWidth();
		var anchorHeight = $anchor.outerHeight();

		// Calculate the position to center the .window over the .marker
		var topPosition = anchorOffset.top - containerOffset.top + (anchorHeight / 2) - (targetHeight / 2);
		var leftPosition = anchorOffset.left - containerOffset.left + (anchorWidth / 2) - (targetWidth / 2);

		// Ensure the .window stays fully within the .image-container
		if ( topPosition < 0 ) {
			topPosition = 0; // Prevent going above the container
		} else if ( topPosition + targetHeight > containerHeight ) {
			topPosition = containerHeight - targetHeight; // Prevent going below the container
		}

		if ( leftPosition < 0 ) {
			leftPosition = 0; // Prevent going left of the container
		} else if ( leftPosition + targetWidth > containerWidth ) {
			leftPosition = containerWidth - targetWidth; // Prevent going right of the container
		}

		// Set the final position of the target div
		$targetDiv.css( {
			top: topPosition + 'px',
			left: leftPosition + 'px',
		} );
	} );

	$( '.close-window' ).on( 'click', function() {
		$( this ).closest( '.window' ).addClass( 'pointer-events-none opacity-0' );
	} );

	// Event listener to close all windows when clicking on the image background
	$( '.image-container' ).on( 'click', function( event ) {
		// Check if the click is not on a marker
		if ( !$( event.target ).closest( '.marker' ).length ) {
			$( '.window' ).addClass( 'opacity-0 pointer-events-none' );
		}
	} );

} );

function closeMenu() {
	$( 'body' ).removeClass( 'active-menu' );
	$( '.site-navigation-control, .site-navigation-container' ).removeClass( 'active' );

	$( '.site-navigation-control-open' ).removeClass( 'active' );
	$( '.site-navigation-container a' ).removeClass( 'active' );

	navTimeouts.forEach( function( timeout ) {
		clearTimeout( timeout );
	} );

	navTimeouts = [];
}

/* 3/24/2017 Sanitize_Target_Blank.htm https://gist.github.com/JamoCA/80f65eb07f054b1326221bd4f15868d6 */
function sanitizeTargetBlank() {
	$( 'a[rel~=external]' ).prop( 'target', '_blank' );
	$( 'a[target="_blank"]' ).each( function() {
		var a = $( this );
		if ( location.hostname !== this.hostname ) {
			var originalRel = (this.rel === undefined) ? '' : this.rel.toLowerCase();
			var newRel = originalRel.split( " " );
			if ( originalRel.indexOf( 'noopener' ) === -1 ) {
				newRel.push( 'noopener' );
			}
			if ( originalRel.indexOf( 'noreferrer' ) === -1 ) {
				newRel.push( 'noreferrer' );
			}
			if ( originalRel.indexOf( 'nofollow' ) === -1 ) {
				newRel.push( 'nofollow' );
			}
			a.attr( 'rel', newRel.join( " " ).trim() );
		}
	} );
	console.log( 'External AHREF links have been sanitized.', new Date );
}

function viewRel() {
	var linkLog = [];
	console.log( 'Identifying all AHREF links with target="_blank"...' );
	$( 'a[target="_blank"]' ).each( function( i ) {
		var a = $( this );
		var r = a.attr( 'rel' );
		if ( r !== undefined ) {
			r = r.split( " " );
		}
		var entry = {
			'index': i,
			'linkText': a.text(),
			'href': a.attr( 'href' ),
			'target': a.attr( 'target' ),
			'rel': r,
		};
		linkLog.push( entry );
	} );
	console.table( linkLog );
}
